
import React from 'react';
import { Link } from 'react-router-dom';
import { Filter, Calendar } from 'lucide-react';

const FilterCtaSection = () => {
  return (
    <section className="section-padding bg-gradient-to-br from-autocare-blue to-autocare-blue-light text-white">
      <div className="page-container">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            هل أنت مستعد للحفاظ على أداء مركبتك؟
          </h2>
          <p className="text-lg mb-8 opacity-90">
            احجز خدمة تغيير الفلتر مع فنيينا المعتمدين واحتفظ بأداء محركك في أفضل حالاته.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/shops"
              className="btn-primary-light flex items-center justify-center"
            >
              <Calendar className="mr-2 h-5 w-5" />
              حجز موعد
            </Link>
            <Link
              to="/products"
              className="btn-secondary-light flex items-center justify-center"
            >
              <Filter className="mr-2 h-5 w-5" />
              تصفح الفلاتر
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FilterCtaSection;
